
import Terra1 from '../Terra (1).webp'
import Terra2 from '../Terra (2).webp'
import Terra3 from '../Terra (3).webp'
import Terra4 from '../Terra (4).webp'



const Terraimages =[
    Terra1,Terra2,Terra3,Terra4
]

export default Terraimages;